export type ThemeMode = "light" | "dark";

export const THEME_STORAGE_KEY = "appearance";

const THEME_META_COLORS: Record<ThemeMode, string> = {
  light: "#f7f8fa",
  dark: "#08090a",
};

export const getStoredTheme = (): ThemeMode | null => {
  const value = localStorage.getItem(THEME_STORAGE_KEY);
  if (value === "light" || value === "dark") {
    return value;
  }
  return null;
};

export const resolveTheme = (stored: ThemeMode | null): ThemeMode => stored ?? "light";

export const applyTheme = (theme: ThemeMode) => {
  const root = document.documentElement;
  root.dataset.theme = theme;
  root.classList.toggle("dark", theme === "dark");
  root.style.colorScheme = theme;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) {
    meta.content = THEME_META_COLORS[theme];
  }
};

export const initTheme = () => {
  applyTheme(resolveTheme(getStoredTheme()));
};

export const persistTheme = (theme: ThemeMode) => {
  localStorage.setItem(THEME_STORAGE_KEY, theme);
  applyTheme(theme);
};
